import { boolean, Infer, type } from "superstruct";
import { OfferErrorStruct } from "@/shared/types/OfferErrorType";
import { GetOfferApiProps } from "@features/ottPurchase/types/GetOfferApi";

export type PostEntitlementType = GetOfferApiProps;

export const PostEntitlementResponseStruct = type({
  data: type({
    access_granted: boolean(),
  }),
});

export type PostEntitlementResponseType = Infer<
  typeof PostEntitlementResponseStruct
>;

export const PostEntitlementErrorResponseStruct = type({
  error: OfferErrorStruct,
});

export type PostEntitlementErrorResponseType = Infer<
  typeof PostEntitlementErrorResponseStruct
>;
